// src/components/OAuthCallback.js

import React, { useEffect } from "react";
import LoadingScreen from "./UI/loading-screen";
import { useLocation, useNavigate } from "react-router-dom";
import { baseUrl } from "../index";
import { useCookies } from "react-cookie";

const OAuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [cookies, setCookie] = useCookies([], {
    doNotParse: true,
  });
  let isLocal = window.location.href.indexOf("localhost") != -1;
  useEffect(() => {
    console.log("OAuthCallback component mounted");
    const urlParams = new URLSearchParams(location.search);
    const code = urlParams.get("code");
    console.log("auth code", code);

    if (code) {
      // Call your backend API to exchange the code for an access token
      fetch("https://payments-api-uat.accorplus.com/v1/dev/callback", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ code }),
      })
        .then((response) => response.json())
        .then((data) => {
          console.log("Token exchange successful:", data);
          // Handle token exchange data here, for example, navigate to a new page or update state
          const { cookieValue } = data;
          if (cookieValue) {
            setCookie("allUserData", cookieValue, {
              path: "/",
              maxAge: 21600,
              sameSite: "strict",
            });
            if (isLocal) {
              navigate(`${baseUrl}`);
            } else {
              navigate(`${baseUrl}registration?redirect=F`);
            }
          }
        })
        .catch((err) => {
          console.error("Error during token exchange:", err);
        });
    } else {
      console.error("Authorization code not found in URL.");
    }
  }, [location]); // Ensure location dependency is included for useEffect

  return (
    <>
      <LoadingScreen />
    </>
  );
};

export default OAuthCallback;
